<template>
    <button class="calendar-list-event" type="button" @click="openDialog">
        <div class="calendar-list-event__header">
            <span class="calendar-list-event__time">{{ formatTime(event.startDate) }}</span>
            <h4 class="calendar-list-event__title">{{ event.title }}</h4>

            <p class="calendar-list-event__venue" v-if="event.venue">{{ event.venue.title }}</p>

            <div v-if="event.filters?.categories" class="calendar-list-event__footer">
                <calendar-info :event="event"/>
            </div>
        </div>

        <figure
            v-if="event.image"
            class="calendar-list-event__media o-figure"
            itemscope
            itemtype="http://schema.org/ImageObject"
        >
            <picture class="calendar-list-event__intrinsic-ratio">
                <source
                    :srcset="`
                        ${getImageURL(event.image.src, 180, 150)},
                        ${getImageURL(event.image.src, 360, 300)} 2x`"
                    media="(min-width: 800px)"
                >
                <img
                    class="donation-panel__image"
                    :src="getImageURL(event.image.src, 180, 150)"
                    width="500"
                    height="250"
                    :alt="event.image.alt || ''"
                >
            </picture>
        </figure>
    </button>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
import CalendarInfo from './calendar-info.vue';

export default defineComponent({
    name: 'CalendarListEvent',
    components: { CalendarInfo },
    props: {
        event: {
            type: Object,
            required: true,
        },
        opendialog: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const dialog = ref(null);

        const getImageURL = (url, width, height) => {
            return url + '?w=' + width + '&h=' + height;
        }

        const formatTime = (date) => {
            if (!date) return ''
            const d = new Date(date)
            let hours = d.getHours()
            const minutes = d.getMinutes()
            const ampm = hours >= 12 ? 'pm' : 'am'
            hours = hours % 12
            hours = hours ? hours : 12 // the hour '0' should be '12'
            const minutesStr = minutes < 10 ? '0' + minutes : minutes
            return `${hours}:${minutesStr}${ampm}`
        }

        const openDialog = (() => {
            props.opendialog(props.event);

            dialog.value.showModal();
        });

        onMounted(() => {
            dialog.value = document.getElementById('calendar-popup');
        })

        return {
            openDialog,
            formatTime,
            getImageURL
        };
    },
});
</script>
